import { createSelector } from 'reselect';

const selectiesubscriptions = (state: any) => state.iesubscriptions;


export const selectiesubscriptionsCurrentItem = createSelector([selectiesubscriptions], (iesubscriptions) => iesubscriptions.current);

export const selectiesubscriptionsListItems = createSelector([selectiesubscriptions], (iesubscriptions) => iesubscriptions.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectiesubscriptionsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectiesubscriptionsQueryItems = createSelector([selectiesubscriptions], (iesubscriptions) => iesubscriptions.query);

export const selectiesubscriptionsCreatedItem = createSelector([selectiesubscriptions], (iesubscriptions) => iesubscriptions.create);

export const selectiesubscriptionsUpdatedItem = createSelector([selectiesubscriptions], (iesubscriptions) => iesubscriptions.update);

export const selectiesubscriptionsReadItem = createSelector([selectiesubscriptions], (iesubscriptions) => iesubscriptions.read);

export const selectiesubscriptionsDeletedItem = createSelector([selectiesubscriptions], (iesubscriptions) => iesubscriptions.delete);

export const selectiesubscriptionsSearchedItems = createSelector([selectiesubscriptions], (iesubscriptions) => iesubscriptions.search);

export const selectiesubscriptionsItemsCount = createSelector([selectiesubscriptions], (iesubscriptions) => iesubscriptions.count);

export const selectiesubscriptionsItemsFilter = createSelector([selectiesubscriptions], (iesubscriptions) => iesubscriptions.filter);